export enum PhaseType {
  MAP = 'map',
  SITE_PLAN = 'site-plan',
  PROPOSAL = 'proposal',
  DEFAULT = 'default'
}

export type PhaseStatus = 'open' | 'closed' | 'active' | 'completed' | 'upcoming';

export interface IProject {
  id: string;
  ownerId?: string;
  owner?: {
    id?: string;
    name?: string;
    email?: string;
  };
  name: string;
  status: string;
  users: IProjectUser[];
  meta: Record<string, any>;
  phases: IPhase[];
}

export interface IProjectUser {
  id: string;
  email: string;
  name: string;
  role: string;
}

export interface IPhase<TData = Record<string, any> | null> {
  id: string;
  projectId?: string;
  name: string;
  type: PhaseType;
  progress: number;
  sequence: number;
  locked: boolean;
  status?: PhaseStatus;
  users?: IProjectUser[];
  data?: TData;
  notes?: INote[];
  isActive?: boolean;
  isHidden?: boolean;
  meta?: Record<string, any>;
}

export interface INote {
  id: string;
  text: string;
  createdAt?: string;
  authorId?: string;
}

export type PhaseEventName = 'load' | 'save' | 'data:update' | 'activate' | 'deactivate' | 'status';

export interface PhaseEvent<TPayload = unknown> {
  name: PhaseEventName;
  payload?: TPayload;
}

export type PhaseEventHandler<TPayload = unknown> = (event: PhaseEvent<TPayload>) => void;

export interface PhaseModel<TData = unknown> {
  type: PhaseType;
  phase: IPhase<TData>;
  on: (name: PhaseEventName, handler: PhaseEventHandler<TData>) => () => void;
  load: () => Promise<IPhase<TData>>;
  save: (update?: Partial<IPhase<TData>>) => Promise<IPhase<TData>>;
  updateData: (data: TData) => IPhase<TData>;
  activate: () => IPhase<TData>;
  deactivate: () => IPhase<TData>;
  sync: (phase: IPhase<TData>) => void;
}
